<ng-content></ng-content>

<button [tkDialogClose]="true" class="cross">
	<tk-icon icon="cross" size="32" />
</button>
